import { render, staticRenderFns } from "./AdminPortal.vue?vue&type=template&id=6cb89b63&scoped=true"
import script from "./AdminPortal.vue?vue&type=script&lang=js"
export * from "./AdminPortal.vue?vue&type=script&lang=js"
import style0 from "./AdminPortal.vue?vue&type=style&index=0&id=6cb89b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb89b63",
  null
  
)

export default component.exports